const SITE_NAME = "Bite Balance Admin";
const SITE_DESCRIPTION =
  "Bite Balance admin panel — manage users, meals, fitness data, and health analytics.";
const SITE_AUTHOR = "Bite Balance";

function setMetaTag(
  selector: string,
  attribute: "name" | "property",
  key: string,
  content: string
) {
  let tag = document.querySelector<HTMLMetaElement>(
    `meta[${attribute}="${key}"]`
  );

  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attribute, key);
    document.head.appendChild(tag);
  }

  tag.setAttribute("content", content);
}

export function applyBiteBalancePageMeta(pageTitle?: string) {
  const fullTitle = pageTitle ? `${pageTitle} | ${SITE_NAME}` : SITE_NAME;

  document.title = fullTitle;

  setMetaTag("meta", "name", "description", SITE_DESCRIPTION);
  setMetaTag("meta", "name", "author", SITE_AUTHOR);
  setMetaTag("meta", "property", "og:title", fullTitle);
  setMetaTag("meta", "property", "og:description", SITE_DESCRIPTION);
  setMetaTag("meta", "name", "twitter:site", "@BiteBalance");
}
